import {split, trimEnd} from 'lodash-es';

export const encodeUrlValue = (value: string) => (
    encodeURIComponent(value)
        .replace(
            /[!'()*~]/g,
            c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
        )
);

/**
 * Удаляет «повторяющиеся» хвостовые слеши из URL‑строки **без** RegExp.
 *
 * Эквивалент двух вызовов:
 * ```ts
 * url.replace(/\/+(?=\?)/, '')   // убирает все '/' прямо перед первым '?'
 *    .replace(/\/+$/, '');       // убирает все '/' в самом конце строки
 * ```
 *
 * Как работает функция:
 * 1. Разбиваем строку на `path` и `query` (часть после «?»).
 * 2. Для `path` удаляем все завершающие `/` — это соответствует
 *    первому `replace(/\/+(?=\?)/, '')`.
 * 3. Для `query` обрезаем **его собственные** хвостовые `/` —
 *    тем самым достигается эффект `replace(/\/+$/, '')`,
 * 4. Возвращаем совмещенные path и query
 *
 * @param url — произвольный абсолютный или относительный URL.
 *              Корректность формата не проверяется.
 * @returns Новая строка без лишних слешей. Исходный `url` не изменяется.
 *
 * @example
 * trimUrlSlashes('https://example.com/foo///') → 'https://example.com/foo'
 *
 * @example
 * trimUrlSlashes('https://example.com/foo///?a=1///') → 'https://example.com/foo?a=1'
 *
 * @example
 * trimUrlSlashes('https://example.com/path?param=//')  → 'https://example.com/path?param='
 */
export const trimUrlSlashes = (url: string): string => {
    const [path, query] = split(url, '?', 2) as [string, string?];

    const trimmedPath = trimEnd(path, '/');
    const trimmedQuery = trimEnd(query ? `?${query}` : '', '/');

    return `${trimmedPath}${trimmedQuery}`;
};
